/* eslint-disable import/prefer-default-export */
import { makeEntityScaffold } from '@classpass/saga-tools';

export const babelfishGetSupportedLocales = makeEntityScaffold('SAGA.API.BABELFISH.SUPPORTED', client =>
  client.babelfish.getSupportedLocales()
);
